// extracted by mini-css-extract-plugin
export default {"cartContainer":"BK","summarycontent":"CK","offset":"EK","leaf":"FK","summaryclosed":"GK","summaryheader":"HK","summaryitems":"IK","summaryprice":"JK","buttonopen":"KK","buttondown":"LK","summaryfixed":"MK","usdnotification":"NK","renew":"OK","promowrapper":"PK","ordersummarywrap":"QK","simplewrap":"RK"};
    if(module.hot) {
      // 1738836197129
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  